module.exports = __webpack_public_path__ + "img/mute_ringtone.585d753f.svg";